<template>
  <div id="container-floating">

  </div>
</template>

<script>
  export default {
    name: 'main-bottom-right-buttons'
  }
</script>

<style>
  #floating-button{
    width: 55px;
    height: 55px;
    border-radius: 50%;
    background: #1bb99a;
    position: fixed;
    bottom: 30px;
    right: 30px;
    cursor: pointer;
    box-shadow: 0px 2px 5px #666;
    z-index: 1000000;
  }

  #floating-button i {
    color: white;
    position: absolute;
    top: 0;
    display: block;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    padding: 0;
    margin: 0;
    line-height: 55px;
    font-size: 38px;
    font-weight: 300;
    animation: plus-out 0.3s;
    transition: all 0.3s;
  }

  #container-floating{
    position: fixed;
    width: 70px;
    height: 70px;
    bottom: 30px;
    right: 30px;
    z-index: 50px;
  }
</style>



// WEBPACK FOOTER //
// MainBottomRightButtons.vue?5c9616e2